import { Message } from "./Message";

export class Response<T> {
    entityList: T[];
	entity:T;
	totalRecords: number;
	status: number;
	message: Message;
}